module.exports = __webpack_public_path__ + "static/sarofsky-f8c6f70faf01c075b807ab043916f1c1.png";